module.exports = __webpack_public_path__ + "img/gallery-3.f27c7cb7.jpg";